<div class="mx-n3 my-n3 Immigration-home">
    <img src="design/images/Immigration-img.png" (load)="onImageLoad($event)">
    <div class="row" *ngIf="!loading">
        <div class="col-6 p-5 privacy">
            <h3  class="yellow-head"> Privacy Notice – Transition management Tool</h3>
            <br>
            
            <div class="privacy-content-scroll pr-4">
              <h6 class="yellow-head">1. Introduction</h6>
              <p>
                This Privacy Notice is intended to describe the practices EY follows in relation to the Transition
                Management Tool (“Tool”) with respect to the privacy of all individuals whose personal data is processed and
                stored in the Tool.
                This Privacy Notice should be read together with the <a class="link-primary" href="https://www.ey.com/en_gl/privacy-statement"
                  target="_blank">ey.com Privacy Statement</a>, and in case of any conflict with the <a class="link-primary"
                  href="https://www.ey.com/en_gl/privacy-statement" target="_blank">ey.com Privacy Statement</a>, the terms
                of this Privacy Notice will prevail. Please read this Privacy Notice carefully.
              </p>
    
              <h6 class="yellow-head">2. Who manages the Tool?</h6>
              <p>
                “EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”), each of which is a
                separate legal entity and can determine the purposes and means for data processing in its own right (i.e.,
                act as a data controller or in a similar capacity) .
              </p>
              <p>
                The entity that is acting as data controller (or similar capacity) by providing this Tool on which your
                personal data will be processed and stored is :
    
              </p>
              <ul>
                <li class="whiteText">For the personal data of EY personnel: The data controller is the EY entity which employs you. </li>
                <li class="whiteText">For the personal data of third-party personnel: The data controller is the EY local member firm with
                  which the third party has a relationship.</li>
              </ul>
              <p>
                You can find a list of local EY member firms and affiliates on the ey.com Privacy Statement.
              </p>
              <p>
                The personal data in the Tool is shared by the above data controller with one or more member firms of EYG
                (see “Who can access your personal data” section 6 below).
              </p>
              <p>
                The Tool is hosted on servers in an EY managed Microsoft Azure data center in Ireland.</p>
              <h6 class="yellow-head">3. How does the Tool process personal data?</h6>
    
    
              <p>The Tool manages the Recruitment, Pre- joining, Immigration and exit processes across countries in the MENA
                region.
              </p>
              <p> Your personal data processed in the Tool is used as follows:</p>
              <ul>
                <li class="whiteText" >Personal data of users of the Tool is used to provide them authenticated access to the Tool.</li>
                <li class="whiteText">Personal data of new hires/pre-joining candidates is processed to facilitate joining, recruitment and
                  immigration processes. </li>
                <li class="whiteText">
                  Personal data of EY MENA employees is used to manage their immigration and exit activities in the course
                  of their employment with EY.
                </li>
              </ul>
    
    
              <p>EY relies on the following basis to legitimize the processing of your personal data in the Tool: </p>
              <ul>
                <li class="whiteText">
                  The data subject has given consent to the processing of their personal data for one or more specific
                  purposes:
                </li>
                <p>For processing of personal data of minor children of pre-joining candidates and employees
                </p>
                <p>
                  Where we process your personal data based on your consent, the provision of your personal data to EY is
                  optional. However, if you do not provide all or part of your personal data, we may be unable to carry out
                  the purposes for processing. You have the right to withdraw your consent at any time.
                </p>
                <li class="whiteText">
                  Processing is necessary for the performance of a contract to which the data subject is party or in order
                  to take steps at the request of the data subject prior to entering into a contract:
                  <p>- For processing of personal data of pre-joining candidates to facilitate joining and entering into an
                    employment contract/immigration activities or assessments are being conducted for such candidates</p>
                  <p>- For processing of personal data of EY employees' immigration activities</p>
                </li>
                <li class="whiteText">
                  Processing is necessary for compliance with a legal obligation to which the data controller (i.e. EY) is
                  subject.
                </li>
                <p>For processing of personal data of pre-joining candidates and EY employees in pursuance of legal
                  obligations on EY emanating from employment and social security laws (such as issuance of labour card, ID
                  card, mandatory immigration requirements, insurance requirements etc.)</p>
                <li class="whiteText">
                  Processing of your personal data is necessary for the purposes of the legitimate interests pursued by the
                  data controller or by a third party, except where such interests are overridden by the interests or
                  fundamental rights and freedoms of the data subject which require protection of personal data. The
                  specific legitimate interest(s) are: (i) Complying with regulatory and legal obligations, (ii) Human
                  Resource management, including performance reviews and recruitment; and (iii) EY office workplace
                  management.
    
                </li>
                <p>
                  - For processing personal data of EY employees for immigration and exit activities</p>
                <p>- For processing of personal data of EY employees who are the administrative users of the Tool</p>
                <p>- For processing of personal data of EY new hires/pre-joining candidates for EY's internal HR
                  administration and reporting purposes</p>
    
    
              </ul>
              <p>(Where EY processes personal information on the grounds of “EY's legitimate interest”, such legitimate
                interest is within the purposes related to EY's contractual relationship with the data subject, including:
                the processing is necessary for the controller or data subject to carry out their obligations and exercise
                their legally established rights in the field of employment, social security, or laws concerned with social
                protection, to the extent permitted by those laws and therefore, is necessary for the execution of an
                existing contract to which the data subject is a party, the “existing contract” being the employment
                contract between EY and the data subject)</p>
              <p>You have the right to object at any time, on grounds relating to your particular situation, to the
                processing of personal data concerning you based on the above legitimate interest(s).</p>
    
    
    
    
              <h6 class="yellow-head">4. What type of personal data is processed in the Tool?</h6>
              <p>The Tool processes these personal data categories:</p>
              <p><b>EY Partners and Personnel: </b>Name, Contact Number, Email ID, Religion, Prior EY employment history,
                Notice period, Academic qualifications, Marital status, Emergency details, Child details, Spouse details,
                Residency permit status, Vaccination Status, Date of Birth, Gender, Nationality, Residential Address, Next
                of Kin, Passport details, Photograph, Family book number (in UAE), Bi-Lingual, Medical Insurance Plan,
                Employee personal email, Visa Details, GPN, EY email id, GUI, Office location, Office location country,
                Office legal entity, Service line, Sub service line, Specialty, Department, Rank, Grade, Personal
                contact-email & number, EY Asset Details like Laptop, Exit date, Expense/ Leave details, and EY AMEX Credit
                Card (Managers &Above)</p>
    
              <p><b> EY pre-joining candidates: </b>Name, Contact Number, Email ID, Religion, prior EY employment history,
                Notice period, Academic qualifications, Marital status, Emergency details, Child details, Spouse details
                Residency permit status, Vaccination Status, Date of Birth, Gender, Nationality, Residential Address, Next
                of Kin, Passport details, Photograph, Family book number (in UAE) and if bi-lingual.
              </p>
              <p>Your personal data is sourced from:</p>
              <ul>
                <li class="whiteText">
                  Provided directly by EY Partners, employees or contractors</li>
                <li class="whiteText">A feed from other EY systems: MENA Employee Records Repository, SuccessFactors etc.</li>
                <li class="whiteText">Provided by EY new hires who will be joining the organisation after issuance of offer letter</li>
    
    
    
              </ul>
    
              <h6 class="yellow-head">5. Sensitive personal data</h6>
              <p>Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or
                philosophical beliefs, trade union membership, genetic data, biometric data, data concerning health or data
                concerning sex life or sexual orientation.</p>
              <p><i>The following sensitive personal data is collected and processed in the Tool:</i></p>
              <ul>
                <li> Children details (only for the purposes of Egypt)</li>
                <li>Religion</li>
                <li>Vaccination status, medical insurance plan </li>
    
              </ul>
              <h6 class="yellow-head">6. Who can access your personal data?</h6>
              <p>Your personal data is accessed in the Tool by the following persons/teams:</p>
    
    
              <!-- <ul>
                <li>MENA Talent team (Recruitment team, Pre-boarding & Immigration teams, Offboarding teams) based in MENA region and EY GDS(India).</li>
                <li>In addition, IBM employees from Talent transformation services group who supports MENA Talent in the recruitment, pre-joining, immigration and offboarding processes.</li>
                <li>Candidates who are issued offer with EY can access tool and view/enter/update only their own information. Once the profile is approved by talent team, access for candidate will be revoked.</li>
              </ul> -->
              <div class="table-scroll privacy-table">
                <table class="table mt-1">
                  <tr>
                    <th>USER GROUP</th>
                    <th>LOCATION</th>
                    <th>PURPOSE</th>
                    <th>ACCESS</th>
                    <th>AMOUNT</th>
                  </tr>
                  <tr>
                    <td>Group name</td>
                    <td>Identify country</td>
                    <td>The action that the group performs</td>
                    <td>Identify whether access is read, update, add</td>
                    <td>Provide the approx. number of users with access</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>Recruiter</td>
                    <td>UAE, KSA, Qatar, Kuwait, Bahrain, Oman, Jordan, Lebanon, Egypt</td>
                    <td>New hire profile creation</td>
                    <td>Read, update, add</td>
                    <td>15</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>Pre-joining Talent Consultant (PTC)</td>
                    <td>Centrally managed from UAE</td>
                    <td>Pre-boarding activities</td>
                    <td>Read, update, add</td>
                    <td>10</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>Immigration</td>
                    <td>UAE, KSA, Qatar, Kuwait, Bahrain, Oman, Jordan, Lebanon, Egypt</td>
                    <td>Immigration activities (Tracking of Visa status)</td>
                    <td>Read</td>
                    <td>9</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>Off-boarding (Exit) team</td>
                    <td>Jordan, EY GDS & IBM - India</td>
                    <td>Exit process</td>
                    <td>Read, update, add</td>
                    <td>6</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>DB Admin</td>
                    <td>UAE</td>
                    <td>User access management</td>
                    <td>Read, update, add</td>
                    <td>1</td>
                  </tr>
    
                  <tr class="privacy-td-text">
                    <td>IT Support (GDS)</td>
                    <td>India</td>
                    <td>To provide support in case of any application issues</td>
                    <td>Read</td>
                    <td>2</td>
                  </tr>
    
                  <tr class="privacy-td-text">
                    <td>IBM -Talent Transformation Services (EY Contractors)</td>
                    <td>India</td>
                    <td>New hire profile creation, Immigration / and Offboarding activities</td>
                    <td>Read, add, update</td>
                    <td>15</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>BVS (EY External contractors)</td>
                    <td>UAE</td>
                    <td>Immigration activities in Abhudhabi</td>
                    <td>Read, Update</td>
                    <td>2</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>Candidate (Each candidate can access and update only his own information)</td>
                    <td>Across globe
                      (Those who has been issued offer)
                    </td>
                    <td>Key in their personal data</td>
                    <td>Read, update, add -only their own individual data</td>
                    <td>~ 2000 in a year</td>
                  </tr>
                  <tr class="privacy-td-text">
                    <td>All MENA employees will have access to the Immigration page</td>
                    <td>Across MENA</td>
                    <td>Input/view their personal data</td>
                    <td>Read, update, add -only their own individual data</td>
                    <td>3000</td>
                  </tr>
    
                </table>
              </div>
              <p>The access rights detailed above involves transferring personal data in various jurisdictions (including
                jurisdictions outside the European Union) in which EY operates (EY office locations are listed at
                <a class="link-primary" href="https://www.ey.com/en_gl/locations"  target="_blank">
                https://www.ey.com/en_gl/locations</a>). An overview of EY network entities providing services to external
                clients is accessible <a class="link-primary" href="https://www.ey.com/en_uk/legal-statement"  target="_blank">here </a> (See Section 2 (About EY) - “View a list of EY member firms and affiliates”). EY
                will process your personal data in the Tool in accordance with applicable law and professional regulations
                in your jurisdiction. Transfers of personal data within the EY network are governed by EY's <a class="link-primary" href="https://www.ey.com/en_gl/data-protection-binding-corporate-rules-program"  target="_blank"> Binding
                Corporate Rules</a>.</p>
             
              <p>We transfer or disclose the personal data we collect to third-party service providers (and their
                subsidiaries and affiliates) who are engaged by us to support our internal ancillary processes. For example,
                we engage service providers to provide, run and support our IT infrastructure (such as identity management,
                hosting, data analysis, back-up, security and cloud storage services) and for the storage and secure
                disposal of our hard copy files. It is our policy to only use third-party service providers that are bound
                to maintain appropriate levels of data protection, security and confidentiality, and that comply with any
                applicable legal requirements for transferring personal data outside the jurisdiction in which it was
                originally collected. </p>
              <p>To the extent that personal data has been rendered anonymous in such a way that you or your device are no
                longer reasonably identifiable, such information will be treated as non-personal data and the terms of this
                Privacy Notice will not apply.
              </p>
              <p>For data collected in the European Economic Area (EEA) or which relates to individuals in the EEA, EY
                requires an appropriate transfer mechanism as necessary to comply with applicable law. The transfer of
                personal data from the Tool to Microsoft/IBM/BVS is governed by an agreement between EY and the vendor that
                includes standard data protection clauses adopted by the European Commission.</p>
              <h6 class="yellow-head">7. Data retention</h6>
              <p>Our policy is to retain personal data only for as long as it is needed for the purposes described in the
                section “How does the Tool process personal data”. Retention periods vary in different jurisdictions and are
                set in accordance with local regulatory and professional retention requirements. </p>
              <p>In order to meet our professional and legal requirements, to establish, exercise or defend our legal rights
                and for archiving and historical purposes, we need to retain information for significant periods of time.
              </p>
              <p>The policies and/or procedures for the retention of personal data in the Tool are: </p>
              <ul>
                <li class="whiteText">The total retention period is defined and will be implemented in accordance with the <a class="link-primary" href="https://find.ey.net/discover/sitepages/home.aspx?detailPath=ZYFCSFS674FF-4-3034#detailPath=ZYFCSFS674FF-4-3034"  target="_blank"> EY Records
                  Retention Global Policy</a> and the relevant <a class="link-primary" href="https://ig2.ironmountainconnect.com/ey/p/grs/section/country-retention-schedules"  target="_blank"> Country Retention Schedule (CRS)</a>.
                </li>
                <li class="whiteText">Log Data will be retained in accordance with the <a class="link-primary" href="https://sites.ey.com/sites/informationsecurity/Policy Library/Logging_Policy.pdf"  target="_blank"> EY IT Logging Policy. </a></li>
              </ul>
              <p>After the end of the data retention period, your personal data will be deleted. </p>
              <h6 class="yellow-head">8. Security</h6>
              <p>EY protects the confidentiality and security of information it obtains in the course of its business.
                Access to such information is limited, and policies and procedures are in place that are designed to
                safeguard the information from loss, misuse and improper disclosure. Additional information regarding our
                approach to data protection and information security is available in our
                <a class="link-primary" href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fassets.ey.com%2Fcontent%2Fdam%2Fey-sites%2Fey-com%2Fen_gl%2Ftopics%2Fconsulting%2Fey-protecting-your-data-brochure-v2.pdf&data=05%7C01%7CEvangelia.Mavrovounioti%40uk.ey.com%7C1a4a52e2631542f349d908db4bc8f0c2%7C5b973f9977df4bebb27daa0c70b8482c%7C0%7C0%7C638187098628892489%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=4aVx9v7vi%2FC%2Fw7zZjni1F89TCu6LSbe8hAPrfgxxMNA%3D&reserved=0"  target="_blank">
                ey-protecting-your-data-brochure-v2.pdf brochure</a>.</p>
              <h6 class="yellow-head">9. Controlling your personal data</h6>
              <p>EY will not transfer your personal data to third parties (other than any external parties referred to in
                section 6 above) unless we have your permission or are required by law to do so. </p>
              <h6 class="yellow-head">10. Your rights in relation to your personal data </h6>
              <p>Depending on the applicable jurisdiction, you may have certain rights in relation to your personal data,
                including:</p>
              <ul>
                <li class="whiteText">
                  To request details of the personal data EY processes about you and to access the personal data that EY
                  processes about you</li>
                <li class="whiteText"> To have your personal data corrected, for example, if it is incomplete or incorrect</li>
                <li class="whiteText"> To restrict or object to the processing of personal data or request the erasure of your personal data
                </li>
                <li class="whiteText"> To receive a copy of the personal data which you have provided to EY in a structured, commonly used and
                  machine-readable format which you can re-use for your own purposes (known as “data portability”)</li>
                <li class="whiteText"> Where you have provided consent to the processing of your personal data, the right to withdraw your
                  consent. </li>
                <li class="whiteText"> The right to complain to a data protection authority (see section “Complaints”)</li>
              </ul>
              <p>If you have any questions about how EY processes your personal data or your rights related to your personal
                data, please send an e-mail to global.data.protection&#64;ey.com.</p>
              <h6 class="yellow-head">11. Complaints</h6>
              <p>If you are concerned about an alleged breach of privacy law or any other regulation, contact EY's Global
                Privacy Leader, Office of the General Counsel, 1 More London Place, London, SE1 2AF, United Kingdom or via
                email at <a class="link-primary" href="mailto:global.data.protection@ey.com"> global.data.protection&#64;ey.com</a>, or<a class="link-primary" href="mailto:Menadataprotection@ae.ey.com"> Menadataprotection&#64;.ey.com </a>or via your usual EY representative.
                An EY Privacy Leader will investigate your complaint and provide information about how it will be handled
                and resolved.</p>
              <p>If you are not satisfied with how EY resolved your complaint, you may have the right to complain to your
                country's data protection authority. You may also have the right to refer the matter to a court of competent
                jurisdiction. </p>
              <p>Certain EY member firms in countries outside the European Union (EU) and the UK have appointed
                representatives in the EU and the UK respectively to act on their behalf if, and when, they undertake data
                processing activities to which the EU General Data Protection Regulation (GDPR) and/or the UK General Data
                Protection Regulation (UK GDPR) applies. Further information and the contact details of these
                representatives are available below: </p>
              <p>
                <a class="link-primary"
                  href="https://www.ey.com/en_gl/data-protection-representative" target="_blank">
                EU data protection representative | EY</a>
              </p>
              <p>
                <a class="link-primary" href="https://www.ey.com/en_rs/uk-data-protection-representative" target="_blank">
                UK Data protection representative (ey.com)</a></p>
              <h6 class="yellow-head">12. Contact us</h6>
              <p>If you have additional questions or concerns, contact your usual EY representative or email
              <a class="link-primary" href="mailto:global.data.protection@ey.com"> global.data.protection&#64;ey.com</a>  or <a class="link-primary" href="mailto:Menadataprotection@ae.ey.com"> Menadataprotection&#64;ae.ey.com</a>.</p>
             
            </div>
              <br>
              
            <form [formGroup]="policyForm" *ngIf="canAcceptPolicy && !isPolicyAccept">
                <p class="form-group my-auto">
                    <input type="checkbox" formControlName="accept" value="agree" id="_agree">  
                    I have read, understood and acknowledge the Privacy Notice, and hereby give my free, explicit, and unconditional consent to the collection, processing, transfer, and use of my Personal Data and Sensitive Data for the purposes stated in the Privacy Notice.
                </p>

                <div class="mt-1">
                    <button class="btn btn-secondary" (click)="privacyAccept()">
                        Accept
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>